import React from 'react';
import { FiMessageSquare } from 'react-icons/fi';

interface ClosedBetaButtonProps {
  onClick: () => void;
}

export const ClosedBetaButton: React.FC<ClosedBetaButtonProps> = ({ onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center gap-3 rounded-xl px-3 py-2 text-left text-sm font-medium transition-colors text-gray-700 hover:bg-gray-50 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-800 dark:hover:text-white"
      aria-label="Open Closed Beta Portal"
    >
      <span className="text-gray-500 dark:text-gray-400 text-lg">
        <FiMessageSquare />
      </span>
      <span className="text-sm font-medium">Closed Beta Portal</span>
    </button>
  );
}; 